export const GET_CRM_LEVEL_INFO_ACTION = "GET_CRM_LEVEL_INFO_ACTION";
export const SET_CRM_LEVEL_INFO_ACTION = "SET_CRM_LEVEL_INFO_ACTION";
